module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_BlackMatted_MockedUp.60a69cbf.jpg";